import {
	CUSTOM_INTEGRATION_URL,
	CUSTOM_INTEGRATION_JSON_URL,
} from 'utils/AllURLs'

export default (id, type) =>
	type === 'json'
		? `
<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => '${CUSTOM_INTEGRATION_JSON_URL}/${id}',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS =>'{
    "first_name": "Tolleen",
    "last_name": "Integration",
    "phone": "6095554466",
    "ABrandNewAttributeNeverBeforeSeen": "Yes",
    "color": "orange",
    "favorite_dinner": "The Bacon Double Cheeseburger",
    "where_are_you": "at a store",
    "favorite_letter": "G"
}',
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/json'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
`
		: `
<?php

$curl = curl_init();

curl_setopt_array($curl, array(
  CURLOPT_URL => '${CUSTOM_INTEGRATION_URL}/${id}',
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_ENCODING => '',
  CURLOPT_MAXREDIRS => 10,
  CURLOPT_TIMEOUT => 0,
  CURLOPT_FOLLOWLOCATION => true,
  CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
  CURLOPT_CUSTOMREQUEST => 'POST',
  CURLOPT_POSTFIELDS => 'first_name=Tolleen&last_name=Integration&phone=6095554466&ABrandNewAttributeNeverBeforeSeen=Yes&color=orange&favorite_dinner=The%20Bacon%20Double%20Cheeseburger&where_are_you=at%20a%20store&favorite_letter=G',
  CURLOPT_HTTPHEADER => array(
    'Content-Type: application/x-www-form-urlencoded'
  ),
));

$response = curl_exec($curl);

curl_close($curl);
echo $response;
`
